import { render, staticRenderFns } from "./ThePersonalData.vue?vue&type=template&id=57d2a864&"
import script from "./ThePersonalData.vue?vue&type=script&lang=js&"
export * from "./ThePersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports